<div class="row" [formGroup]="durationForm" (change)="onInputChange()">
    <div class="col-xs-6">
        <select formControlName="year" class="form-control select-duration">
            <option value="" disabled>Years</option>
            <ng-container *ngFor="let opt of selects.years; trackBy: identify">
                <option [ngValue]="opt.key" [disabled]="opt.disabled">
                    {{ opt.text }}
                </option>
            </ng-container>
        </select>
    </div>
    <div class="col-xs-6">
        <select formControlName="month" class="form-control select-duration">
            <option value="" disabled>Months</option>
            <ng-container *ngFor="let opt of selects.months; trackBy: identify">
                <option [ngValue]="opt.key" [disabled]="opt.disabled">
                    {{ opt.text }}
                </option>
            </ng-container>
        </select>
    </div>
</div>